import { useQuery } from 'react-query';
import { model as phenotypeModel, Phenotype } from './phenotype';

export const phenotypesQueryKey = () => ['phenotypes'];

export const usePhenotypes = () =>
  useQuery<Phenotype[]>(phenotypesQueryKey(), () =>
    phenotypeModel().getList(),
  );
